import { useEffect, useState } from 'react';
import { Check, Pencil, X } from 'lucide-react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';

/** Production title with inline rename (pencil, double-click, Enter to save, Esc to cancel). */
export function ProjectTitle({ title, onRename }) {
  const [editing, setEditing] = useState(false);
  const [val, setVal] = useState(title);
  const [saving, setSaving] = useState(false);
  useEffect(() => { setVal(title); }, [title]);
  const cancel = () => { setVal(title); setEditing(false); };
  async function save() {
    const v = val.trim();
    if (!v || v === title) { cancel(); return; }
    setSaving(true);
    try { await onRename(v); setEditing(false); } finally { setSaving(false); }
  }
  if (!editing) {
    return (
      <div className="flex min-w-0 items-center gap-1.5">
        <div className="truncate text-lg font-semibold" onDoubleClick={() => setEditing(true)} data-testid="ai-movies-project-title">{title}</div>
        <button type="button" onClick={() => setEditing(true)} aria-label="Rename production" title="Rename production"
          className="shrink-0 rounded p-1 text-neutral-500 transition-colors duration-200 hover:bg-neutral-800 hover:text-amber-300" data-testid="ai-movies-rename-btn">
          <Pencil size={14} />
        </button>
      </div>
    );
  }
  return (
    <form onSubmit={(e) => { e.preventDefault(); save(); }} className="flex items-center gap-1.5" data-testid="ai-movies-title-form">
      <Input autoFocus value={val} maxLength={160} onChange={(e) => setVal(e.target.value)} onKeyDown={(e) => e.key === 'Escape' && cancel()}
        className="h-8 w-72 max-w-full border-neutral-700 bg-neutral-900 text-neutral-100" data-testid="ai-movies-title-input" />
      <Button type="submit" size="sm" disabled={saving || !val.trim()} className="h-8 bg-amber-500 px-2 text-neutral-900 hover:bg-amber-400" data-testid="ai-movies-title-save"><Check size={14} /></Button>
      <Button type="button" size="sm" variant="ghost" onClick={cancel} className="h-8 px-2 text-neutral-400" data-testid="ai-movies-title-cancel"><X size={14} /></Button>
    </form>
  );
}
